export enum PillDataType {
    Basic,
    Complex,
    DateRange,
}

export interface TableFilterPillConfig {
    label: string;
    dataType: PillDataType;
    dataKey: string;
    sourceEnum?: Record<string, string>;
    sourceMapper?: (item: any) => any;
    preventRemoval?: boolean;
    isObject?: boolean;
    dateFormat?: string;
    dateRangeMapper?: (startDate: Date, endDate: Date | null) => { startDate: Date; endDate: Date | null };
}
